//See https://intranet.luciad.com/display/PROD/Reactor+brainstorm for job states and transitions

import {PaginationRequestParams} from "../common/util/pagination/PaginationUtil";


export class JobStatus {
  static readonly IDLE = "Idle";
  static readonly SCHEDULED = "Scheduled";
  static readonly QUEUED = "Queued";
  static readonly RUNNING = "Running";
}

export class JobExecutionResult {
  static readonly DID_NOT_RUN = "DID_NOT_RUN";
  static readonly SUCCESS = "Success";
  static readonly FAILED = "Failed";
  static readonly STOPPED = "Stopped";
}

export class JobType {
  static readonly IMPORT = "import";
  static readonly PREPROCESS = "preprocess";
}

export class DecodeFailureResolution {
  static readonly KEEP = "Keep";
  static readonly DELETE = "Delete";
}

export interface Job {
  id: string;
  jobProgress?: number;
  jobState: JobStatus;
  lastExecutionResult: JobExecutionResult;
  lastExecutionTime?: string;
  lastCompletionTime?: string;
  createdBy?: {
    username: string;
  };
  creationTime: string;
}

export interface ImportJob extends Job {
  dataRoot: string;
  dataRootPath: string;
  crawlStats?: {
    crawledFilesCount: number;
    skippedFilesCount: number;
    failedFilesCount: number;
  };
  ignoreDeletedFiles: boolean;
  forceRecrawlFiles: boolean;
  decodeFailureResolution: DecodeFailureResolution;
  jobSchedule?: any;
}

export interface PreprocessJob extends Job {
  service: string;
  serviceTitle: string;
  product: string;
  productTitle: string;
}

export type CompositeJob = ImportJob | PreprocessJob;

export interface FileInfoSearchFilter extends PaginationRequestParams {
  contentRootID?: string;
  crawlJob?: string;
  dateFilter?: string;
  status?: string;
}

export const filtersEqual = (filterA: FileInfoSearchFilter, filterB: FileInfoSearchFilter) => {
  return (!filterA && !filterB) ||
         (filterA && filterB
          && filterA.contentRootID === filterB.contentRootID
          && filterA.status === filterB.status
          && filterA.crawlJob === filterB.crawlJob
          && filterA.dateFilter === filterB.dateFilter);
};

export const calculateLastDurationTime = (startDate: string, endDate: string): string | null => {
  if (startDate && endDate) {
    let ms = Math.abs(Date.parse(startDate) - Date.parse(endDate));
    const hours = Math.floor(ms / 3600000);
    ms %= 3600000;
    const minutes = Math.floor(ms / 60000);
    ms %= 60000;
    const seconds = Math.floor(ms / 1000);
    const milliseconds = ms % 1000;
    const pad = (num, size) => String(num).padStart(size, '0');

    return `${pad(hours, 2)}:${pad(minutes, 2)}:${pad(seconds, 2)}.${pad(milliseconds, 3)}`;
  }
  return null;
}
